import { Grid } from "@mui/material";
import useStyles from "../styles";
import { useEffect, useState } from "react";
// import CameraAltIcon from "@mui/icons-material/CameraAlt";
// import Button from "../../../components/Button";
import InputGroup from "../../../components/FormComponent/InputGroup";
import { httprequest } from "../../../data/api";
import { useUserState } from "../../../context/UserContext";
import { toast } from "react-toastify";
import PageLoader from "../../../components/PageLoader";

const PROFILE_ENDPOINT = "/api/v1/profile";
const PersonalInformation = () => {
  const classes = useStyles();
  const [personalData, setPersonalData] = useState({});
  const [isPageLoading, setIsPageLoading] = useState(false);

  const { userRole } = useUserState();
  // const [isLoading, setIsLoading] = useState(false);
  const [personalDetails, setPersonalDetails] = useState({});
  // const handlePersonalUpdate = () => {
  //   setIsLoading(true);
  //   httprequest.patch(PROFILE_ENDPOINT, personalDetails)
  //     .then((res) => {
  //       setIsLoading(false);
  //       toast.success(res?.data?.message);
  //       window.location.reload();
  //     }).catch((err) => {
  //       setIsLoading(false);
  //       toast.error(err?.response?.message);
  //     });
  // };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setPersonalDetails({ ...personalDetails, [name]: value });
  };

  const getStudentProfile = () => {
    setIsPageLoading(true);
    httprequest.get(`${PROFILE_ENDPOINT}`)
      .then((res) => {
        setIsPageLoading(false);
        setPersonalData(res?.data?.data);
      }).catch((err) => {
        toast.error(err?.response?.data);
      });
  };

  useEffect(() => {
    getStudentProfile();
  }, []);

  return (
    <>
      {isPageLoading ? (<PageLoader />) :
        <Grid container spacing={4}>
          <Grid item lg={3} md={4} sm={12} xs={12}>
            <div className="left-container">
              <h4>Personal Information</h4>
              <h6>Update your personal details here</h6>
              <div className={classes.profilecontainer}>
                <div className={classes.imageviewer}>
                  {(personalData?.display_pic?.file_url) && (
                    <img
                      src={personalData?.display_pic?.file_url}
                      alt="profile"
                      className={classes.previewImage}
                    />
                  )}
                  {/* <div className={classes.pickercontainer}>
                    <input type="file" name="profile_picture" disabled className={classes.profilepicker} />
                    <CameraAltIcon className={classes.camera} />
                  </div> */}
                </div>
              </div>
            </div>

          </Grid>
          <Grid item lg={9} md={8} sm={12} xs={12}>
            <div className="right-container">
              <Grid container spacing={2} className={classes.profileform}>
                <Grid item lg={6} md={6} sm={6} xs={12}>
                  <InputGroup inputType="text" label="First Name" inputName="first_name" defaultValue={personalData?.first_name} onChange={handleChange} disabled={personalData?.role?.name === "student"} />
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={12}>
                  <InputGroup inputType="text" label="Last Name" inputName="last_name" defaultValue={personalData?.last_name} onChange={handleChange} disabled={personalData?.role?.name === "student"} />
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={12}>
                  <InputGroup inputType="text" label="Other Name" inputName="other_name" defaultValue={personalData?.other_name} onChange={handleChange} disabled={personalData?.role?.name === "student"} />
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={12}>
                  <InputGroup inputType="text" label="Role" inputName="role" defaultValue={userRole?.role} disabled onChange={handleChange} />
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={12}>
                  <InputGroup inputType="text" label="Email Address" inputName="email" defaultValue={personalData?.email} onChange={handleChange} disabled />
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={12}>
                  <InputGroup inputType="text" label="Gender" inputName="gender" defaultValue={personalData?.gender} onChange={handleChange} disabled />
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={12}>
                  <InputGroup inputType="text" label="Phone Number" inputName="contact" defaultValue={personalData?.contact || "--/--"} onChange={handleChange} />
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={12}>
                  <InputGroup inputType="text" label="Country" inputName="country" defaultValue={personalData?.country || "--/--"} onChange={handleChange} disabled />
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={12}>
                  <InputGroup inputType="text" label="Region" inputName="region" defaultValue={personalData?.region || "--/--"} onChange={handleChange} />
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={12}>
                  <InputGroup inputType="text" label="State" inputName="state" defaultValue={personalData?.state || "--/--"} onChange={handleChange} disabled />
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={12}>
                  <InputGroup inputType="text" label="town" inputName="town" defaultValue={personalData?.town || "--/--"} onChange={handleChange} disabled />
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={12}>
                  <InputGroup inputType="text" label="Home Address" inputName="home_address" defaultValue={personalData?.home_address || "--/--"} onChange={handleChange} disabled />
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={12}>
                  <InputGroup inputType="text" label="Previous School" inputName="previous_school" defaultValue={personalData?.previous_school || "--/--"} onChange={handleChange} disabled />
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={12}>
                  <InputGroup inputType="text" label="Previous Class Passed" inputName="previous_class_passed" defaultValue={personalData?.previous_class_passed || "--/--"} onChange={handleChange} disabled />
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={12}>
                  <InputGroup inputType="text" label="Height" inputName="height_cm" defaultValue={personalData?.height_cm || "--/--"} onChange={handleChange} disabled />
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={12}>
                  <InputGroup inputType="text" label="Weight" inputName="weight_kg" defaultValue={personalData?.weight_kg || "--/--"} onChange={handleChange} disabled />
                </Grid>
                {/* <Grid item lg={12} md={12} sm={12} xs={12}>
                  <div className={classes.signatureWrap}>
                    <div className={classes.signatureLabel}>
                                   Signature
                    </div>

                    <div className={classes.signatureCard}>
                      {personalDetails?.branding?.signature?.file_url ? (
                        <img src={personalDetails?.branding?.signature?.file_url} alt="Stamp" className={classes.signatureImg} />
                      ) : (
                        <div className={classes.signatureEmpty}>No signature uploaded</div>
                      )}
                    </div>
                  </div>
                </Grid> */}
              </Grid>
              {/* <div className={classes.btnspace}>
                <Button variant="primary" color="btndefault" buttonSize="medium" buttonName="Save Changes" disabled={personalData?.is_active === false} isLoading={isLoading}
                  onClick={handlePersonalUpdate}
                />
              </div> */}
            </div>

          </Grid>
        </Grid>
      }
    </>
  );
};

export default PersonalInformation;
